
  import { Component, Prop, Vue } from "vue-property-decorator";
  import lambdaRequest from "@/helpers/lambdaRequest";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";
  import ResendInvitation from "@/components/invite/ResendInvitation.vue";
  import ResendInvitationConfirmation from "@/components/common/ResendInvitationConfirmation.vue";

  @Component({
    components: {
      ResendInvitationConfirmation,
      ResendInvitation,
    },
  })
  export default class ContractorResendInvitation extends Vue {
    @Prop({ type: String, required: true }) readonly contractorId!: string;
    @Prop({ type: String, required: true }) readonly invitedByUserId!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly givenName!: string;
    @Prop({ type: String, required: true }) readonly familyName!: string;

    processing: boolean = false;
    invitationResent: boolean = false;

    async resendInvitation(): Promise<void> {
      if (this.invitationResent || this.processing) {
        return;
      }

      this.processing = true;

      try {
        await lambdaRequest({
          lambdaName: "resendContractorInvitation",
          requestData: {
            company_id: this.companyId,
            resend_invitation_by_user_id: this.invitedByUserId,
            contractor_id: this.contractorId,
          }
        });

        this.invitationResent = true;
        this.$emit("invitationResent");
        this.$eventBus.emit(NOTIFICATION, Message.successMessage("Invite sent"));
        // window.location.reload();
      } catch(error) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage("Something went wrong!"));
      } finally {
        this.processing = false;
      }
    }
  }
